// extracted by mini-css-extract-plugin
export default {"separator":"ProfitCentresItem_separator__X-gqb","archived":"ProfitCentresItem_archived__s6Ysg","staticCell":"ProfitCentresItem_staticCell__rgtSn"};